import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["loader-container", { 'is-loading': _ctx.isLoading }])
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("div", {
      class: "loader",
      role: "status"
    }, [
      _createElementVNode("div", { class: "dot-container" }, [
        _createElementVNode("div", { class: "dot" }),
        _createElementVNode("div", { class: "shadow" })
      ]),
      _createElementVNode("div", { class: "dot-container" }, [
        _createElementVNode("div", { class: "dot" }),
        _createElementVNode("div", { class: "shadow" })
      ]),
      _createElementVNode("div", { class: "dot-container" }, [
        _createElementVNode("div", { class: "dot" }),
        _createElementVNode("div", { class: "shadow" })
      ]),
      _createElementVNode("div", { class: "dot-container" }, [
        _createElementVNode("div", { class: "dot" }),
        _createElementVNode("div", { class: "shadow" })
      ])
    ], -1)),
    (_ctx.loadingText)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.loadingText), 1))
      : _createCommentVNode("", true)
  ], 2))
}